import PropTypes from 'prop-types';

export default {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  item_name: PropTypes.string,
  received_quantity: PropTypes.number,
  status: PropTypes.string,
  po_number: PropTypes.string,
  phase_line_item_id: PropTypes.number,
  tag_number: PropTypes.number,
  bin: PropTypes.string,
  note: PropTypes.string,
  errors: PropTypes.shape({
    item_name: PropTypes.array,
    received_quantity: PropTypes.array,
    status: PropTypes.array,
    tag_number: PropTypes.array,
    bin: PropTypes.array,
    note: PropTypes.array,
  }),
};



// WEBPACK FOOTER //
// ./client/app/shared/types/warehouseMerchandiseItem.js